import { LOGOUT, SET_DRIVERS, SET_OPEN_ORDERS, SET_ORDERS_IN_PROGRESS } from "../actionTypes";
import { LOGISTICS_ACTION_TYPES } from "../actions/logistic.action";

const initialState = {
	isLoading: false,
	ordersInProgress: {
		totalRows: 0,
		bids: [],
	},
	pastOrders: {
		totalRows: 0,
		bids: [],
	},
	openOrders: {
		totalRows: 0,
		bids: [],
	},
	// ordersInProgress: [],
	drivers: [],
};


const logisticMemberReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_OPEN_ORDERS: {
			return { ...state, openOrders: action.payload };
		}

		case SET_ORDERS_IN_PROGRESS: {
			return { ...state, ordersInProgress: action.payload };
		}

		case SET_DRIVERS: {
			return { ...state, drivers: action.payload };
		}

		case LOGOUT: {
			return { ...state, openOrders: [], ordersInProgress: [], drivers: [] };
		}


		case LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS: {
			return { ...state, isLoading: true }
		}

		case LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_DONE: {
			const newState = structuredClone(state);
			newState.ordersInProgress.bids = action.payload.paginationData;
			newState.ordersInProgress.totalRows = action.payload.totalRecords;
			newState.isLoading = false;
			return newState;
		}

		case LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_ERROR: {
			return { ...state, isLoading: false }
		}

		case LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE: {
			return state;
		}

		case LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE_DONE: {
			const newState = structuredClone(state);
			newState.ordersInProgress.bids = action.payload.paginationData;
			return newState;
		}

		case LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE_ERROR: {
			return state;
		}

		case LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE: {
			return { ...state, isLoading: true };
		}

		case LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE_DONE: {
			const newState = structuredClone(state);
			newState.ordersInProgress.bids = action.payload.paginationData;
			newState.isLoading = false;
			return newState;
		}

		case LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE_ERROR: {
			return { ...state, isLoading: false };
		}

		case LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY: {
			return { ...state, isLoading: true }
		}

		case LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY_DONE: {
			const newState = structuredClone(state);
			newState.ordersInProgress.bids = action.payload.paginationData;
			newState.ordersInProgress.totalRows = action.payload.totalRecords;
			newState.isLoading = false;
			return newState;
		}

		case LOGISTICS_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY_ERROR: {
			return { ...state, isLoading: false };
		}

		case LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS: {
			return { ...state, isLoading: true }
		}

		case LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_DONE: {
			const newState = structuredClone(state);
			newState.openOrders.bids = action.payload.paginationData;
			newState.openOrders.totalRows = action.payload.totalRecords;
			newState.isLoading = false;
			return newState;
		}

		case LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_ERROR: {
			return { ...state, isLoading: false }
		}

		case LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_ON_PAGE_CHANGE: {
			return { ...state, isLoading: true };
		}

		case LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_ON_PAGE_CHANGE_DONE: {
			const newState = structuredClone(state);
			newState.openOrders.bids = action.payload.paginationData;
			newState.isLoading = false;
			return newState;
		}

		case LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_ON_PAGE_CHANGE_ERROR: {
			return { ...state, isLoading: false };
		}

		case LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_PER_PAGE_LIMIT_CHANGE: {
			return { ...state, isLoading: true }
		}

		case LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_PER_PAGE_LIMIT_CHANGE_DONE: {
			const newState = structuredClone(state);
			newState.openOrders.bids = action.payload.paginationData;
			newState.isLoading = false;
			return newState;
		}

		case LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_PER_PAGE_LIMIT_CHANGE_ERROR: {
			return { ...state, isLoading: false }
		}

		case LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_FOR_SEARCHED_QUERY: {
			return { ...state, isLoading: true }
		}

		case LOGISTICS_ACTION_TYPES.GET_OPEN_ORDERS_FOR_SEARCHED_QUERY_DONE: {
			const newState = structuredClone(state);
			newState.openOrders.bids = action.payload.paginationData;
			newState.openOrders.totalRows = action.payload.totalRecords;
			newState.isLoading = false;
			return newState;
		}

		case LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS: {
			return { ...state, isLoading: true }
		}

		case LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_DONE: {
			const newState = structuredClone(state);
			newState.pastOrders.bids = action.payload.paginationData;
			newState.pastOrders.totalRows = action.payload.totalRecords;
			newState.isLoading = false;
			return newState;
		}

		case LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_ERROR: {
			return { ...state, isLoading: false }
		}

		case LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE: {
			return { ...state, isLoading: true };
		}

		case LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE_DONE: {
			const newState = structuredClone(state);
			newState.pastOrders.bids = action.payload.paginationData;
			newState.isLoading = false;
			return newState;
		}

		case LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE_ERROR: {
			return { ...state, isLoading: false };
		}

		case LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE: {
			return { ...state, isLoading: true }
		}

		case LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE_DONE: {
			const newState = structuredClone(state);
			newState.pastOrders.bids = action.payload.paginationData;
			newState.isLoading = false;
			return newState;
		}

		case LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE_ERROR: {
			return { ...state, isLoading: false }
		}

		case LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY: {
			return { ...state, isLoading: true }
		}

		case LOGISTICS_ACTION_TYPES.GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY_DONE: {
			const newState = structuredClone(state);
			newState.pastOrders.bids = action.payload.paginationData;
			newState.pastOrders.totalRows = action.payload.totalRecords;
			newState.isLoading = false;
			return newState;
		}

		case LOGISTICS_ACTION_TYPES.PUT_CANCEL_ASSIGNED_DRIVER: {
			return state;
		}

		case LOGISTICS_ACTION_TYPES.PUT_CANCEL_ASSIGNED_DRIVER_DONE: {
			return state;
		}

		case LOGISTICS_ACTION_TYPES.PUT_CANCEL_ASSIGNED_DRIVER_ERROR: {
			return state;
		}

		default:
			return state;
	}
};

export default logisticMemberReducer;
